import React from "react";
import "./Founder.css";
import Founder_Modal from "../../Common_Component/Founder_Modal/Founder_Modal";

function Founder({
  className,
  knowMore,
  imgSrc,
  nametext,
  headingSubText,
  subHeading,
  subHeadingTwo,
  headingText,
  discriptiontext,
  modalImgSrc,
  ModalNameText,
  modalSubHeadingText,
  modalHeadingText,
  ModalDescriptionText,
}) {
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      <section className={`Founder ${className}`}>
        <div className="container">
          <div className="row justify-content-center me-0 ms-0">
            <div className="col-xl-5  col-md-6  col-lg-6 col-sm-6  col-12">
              <div className="founder-img-holder">
                <div className="img-holder">
                  <img
                    className="founder-img"
                    src={process.env.PUBLIC_URL + imgSrc}
                  />
                </div>
              </div>
            </div>

            <div className="col-xl-7  col-md-12 col-lg-6 col-sm-6  col-12">
              <div className="Founder-content">
                <div className="heading_section">
                  <div className="founder-name-holder">
                    <h2 className="">{nametext}</h2>
                  </div>

                  <div className="sub-heading-holder">
                    <h4>{subHeading}</h4>
                    <h3>
                      {subHeadingTwo}
                      <span> {headingText} </span>
                    </h3>
                  </div>

                  <div className="heading_text_holder">{headingSubText}</div>
                </div>

                <div className="founder-info-holder">
                  <p>{discriptiontext}</p>
                </div>

                {knowMore}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Founder_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        modalImgSrc={modalImgSrc}
        ModalNameText={ModalNameText}
        modalSubHeadingText={modalSubHeadingText}
        modalHeadingText={modalHeadingText}
        ModalDescriptionText={ModalDescriptionText}
      />
    </>
  );
}

export default Founder;
